<template>
  <div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_tzje`) }}
      </div>
      <div style="width:50%">
        {{ (bet / 100).toFixed(2) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_tzbs`) }}
      </div>
      <div style="width:50%">
        {{ tzbs }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_jgbs`) }}
      </div>
      <div style="width:50%">
        {{ jgbs }}
      </div>
    </div>
    <div class="table_tr" :class="{yellow_color:checkWin()}">
      <div style="width:50%">
        {{ $t(`lang.str_game_win_result`) }}
      </div>
      <div style="width:50%">
        {{ checkWin()? $t(`lang.str_t`):$t(`lang.str_f`) }}
      </div>
    </div>
    <div class="table_tr">
      <div style="width:50%">
        {{ $t(`lang.str_jg`) }}
      </div>
      <div style="width:50%">
        {{ (jg / 100).toFixed(2) }}
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin = "isTotalWin"
      :describe_title = "describe_title"
      :describe_content= "describe_content"
      :describe_message="describe_message">
    </DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game3005",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    describe_title:null,
    isTotalWin:false,
    describe_content:null,
    describe_message:null,
    tzbs:0,
    bet:0,
    jgbs:0,
    jg:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {
    checkWin()
    {
       return this.jgbs>this.tzbs;
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/esports/game_3005.vue